import * as React from 'react'

import Headings from '../../atoms/Heading'
import Image from '../../atoms/Image'
import Paragraph from '../../atoms/Paragraph'

interface Props {
  content?: any
  isArticle?: boolean
}

/**
 * SocialMedia Component
 * @param content - Content from the CMS.
 * @param isArticle (optional) - To render article layout
 */
const SocialMedia = ({ content, isArticle }: Props) => {
  return (
    <>
      <div data-testid="socialMedia" className={`layoutSpacing sectionBottomSpacing w-100 bg-white`}>
        <div className="layout">
          <div
            className={`flex ${content?.texColtLayout ? 'flex-col gap-24 xl:flex-row' : `w-100 flex-col ${isArticle ? '' : 'md:w-75 xl:w-60'}`}`}
          >
            {content?.headline && <Headings variant="H2" content={content?.headline} classes="text-purple-100" />}
            {content?.subheadline && <Headings variant="H3" content={content?.subheadline} classes="text-purple-100" />}
            <Paragraph content={content?.contentDescription || content?.bodyText || content?.description} classes="" />
          </div>
          {content?.features && (
            <>
              <div className="flex flex-col gap-16">
                {content?.features?.map((item) => (
                  <div key={item?.sys?.id}>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={item?.fields?.socialMediaUrl}
                      aria-label={item?.fields?.socialMediaPlatform}
                      className="flex items-center gap-8"
                    >
                      <Image
                        imageUrl={item?.fields?.socialMediaIcon?.fields?.file?.url}
                        altText={item?.fields?.socialMediaPlatform}
                        width="24"
                      />
                      <span>{item?.fields?.socialMediaPlatform}</span>
                    </a>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default SocialMedia
